import { QrCodeScannerContract } from './QrCodeScannerContract'
import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning'

export const mlKitQrScannerImplementation: QrCodeScannerContract & {
  listener?: { remove: () => Promise<void> }
} = {
  requestPermission: () => {
    return new Promise((resolve, reject) => {
      return BarcodeScanner.requestPermissions()
        .then((result) => resolve(result.camera === 'granted' || result.camera === 'limited'))
        .catch(() => reject(false))
    })
  },

  scan () {
    return new Promise((resolve, reject) => {
      BarcodeScanner.addListener(
        'barcodesScanned',
        async scanResult => {
          resolve(scanResult.barcodes[0]?.rawValue ?? '')
        },
      ).then(listener => {
        this.listener = listener
      })

      BarcodeScanner.startScan()
    })
  },

  stop () {
    return new Promise(() => {
      return Promise.all([
        BarcodeScanner.stopScan(),
        this.listener?.remove(),
      ])
    })
  },
}
